import apiClient from '../utils/apiClient';

export interface AppReleaseLinkDto {
  key: string; // googleplay | cafebazaar | myket | appstore | sibapp | anardoni | website | custom
  label?: string;
  url: string;
}

export interface AppReleaseDto {
  _id?: string;
  platform: 'android' | 'ios';
  versionName: string;
  versionCode?: number;
  minSupportedVersion: string;
  isForce?: boolean;
  notes?: string;
  storeUrl?: string;
  fallbackUrl?: string;
  links?: AppReleaseLinkDto[];
  directDownloadUrl?: string;
  fileSize?: number;
  isPublished?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const base = `/admin/app-releases`;

export default {
  async list(platform?: 'android' | 'ios'): Promise<AppReleaseDto[]> {
    const resp = await apiClient.get<{ status: string; data: AppReleaseDto[] }>(`${base}`, { params: { platform } });
    return (resp.data as any)?.data || [];
  },
  async create(payload: AppReleaseDto): Promise<AppReleaseDto> {
    const resp = await apiClient.post<{ status: string; data: AppReleaseDto }>(`${base}`, payload);
    return (resp.data as any)?.data;
  },
  async update(id: string, payload: Partial<AppReleaseDto>): Promise<AppReleaseDto> {
    const resp = await apiClient.patch<{ status: string; data: AppReleaseDto }>(`${base}/${id}`, payload);
    return (resp.data as any)?.data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`${base}/${id}`);
  },
  async publish(id: string, isPublished: boolean): Promise<AppReleaseDto> {
    const resp = await apiClient.patch<{ status: string; data: AppReleaseDto }>(`${base}/${id}/publish`, { isPublished });
    return (resp.data as any)?.data;
  },
};


